module.exports = __webpack_public_path__ + "img/92113.cea1d9b7.svg";